import { Form } from 'antd';
import { FormInstance } from 'antd/lib';
import React from 'react';
import styled from 'styled-components';
import QuickBookingCustomerContent from '../QuickBookingV2/CustomerContent';
import QuickBookingTimeContent from '../QuickBookingV2/TimeContent';
import { Repeat, TimeSelectionRef } from '../QuickBookingV2/TimeDate';
import moment, { Moment } from 'moment';
import Box from 'components/Box';
import QuickBookingServiceContent from '../QuickBookingV2/ServiceContent';
import { IStaffItemData } from 'services/shop/types/staff';
import { IQuickBookingV2FormValues, IQuickBookingV2ServiceItem } from '../QuickBookingV2/type';
import QuickBookingStaffContent from '../QuickBookingV2/StaffContent';
import { IStaffListChooseUIRef } from '../QuickBookingV2/Staff';
import toast from 'utils/toast';
import { first, get } from 'lodash';
import { SourceType } from '../AppointmentDetail/v2/CustomerInfo';
import { NumberCustomers } from '../QuickBookingV2/Customer';
import Icon from 'assets/Icons';
export type AppointmentDetailV3UIProps = {
  form: FormInstance<any>;
  timeRef: React.RefObject<TimeSelectionRef>;
  onPickDate: (date: Moment) => Promise<void>;
  staffs: IStaffItemData[];
  getListStaff: (serviceId: string, servicesProps?: IQuickBookingV2ServiceItem[] | undefined) => void;
  onChooseNumCustomer: (value: number) => void;
  staffRef: React.RefObject<IStaffListChooseUIRef>;
  onPickStaff: (item: IStaffItemData) => void;
  handleFinish: (values: IQuickBookingV2FormValues) => Promise<void>;
  onChanceDuration?: (duration: number) => void;
};
const AppointmentDetailV3UI = ({ form, timeRef, onPickDate, staffs, getListStaff, onChooseNumCustomer, handleFinish, staffRef, onPickStaff, onChanceDuration }: AppointmentDetailV3UIProps) => {
  return (
    <FormContainer>
      <Form.Item noStyle name={'repeat'} />
      <Form.Item noStyle name={'duration'} />
      <Form.Item noStyle name={'customerList'} />
      <QuickBookingCustomerContent />
      <Box display='flex' flexDirection='column' style={rightContainerStyle}>
        <Form.Item noStyle name={'numCustomers'}>
          <NumberCustomers onChange={onChooseNumCustomer} />
        </Form.Item>
        <Box alignSelf='stretch' display='flex' alignItems='center' gap='2' py='2' px='4' style={{ borderBottom: ' 1px solid #86909C' }}>
          <div style={{ zoom: 1.2 }}>
            <Form.Item noStyle name={'sourceType'}>
              <SourceType onlyIcon />
            </Form.Item>
          </div>
          <Form.Item noStyle shouldUpdate>
            {({ getFieldValue }) => {
              const date = getFieldValue('date');
              const dateStr = date?.format('MM-DD-YYYY hh:mm A');
              const duration = getFieldValue('duration');
              const endTime = moment(dateStr, 'MM-DD-YYYY hh:mm A').add(duration, 'minutes').format('hh:mm A');
              return (
                <>
                  <ApppointmentTime>
                    <span className='label'>Time:</span>
                    <span className='value'>{dateStr} - {endTime}</span>
                  </ApppointmentTime>
                  <Box style={{ flex: 1 }} />
                  <DurationBox onClick={() => onChanceDuration?.(duration)} type='button'>
                    <span>({duration}m)</span>
                    <div style={{ zoom: 1.5, display: 'flex' }}>
                      <Icon type="changeCustomer" fill='#6FABB6' />
                    </div>
                  </DurationBox>
                </>
              );
            }}
          </Form.Item>
          {/* <Form.Item noStyle label={'Repeat'} name={'repeat'}>
            <Repeat />
          </Form.Item> */}
        </Box>
        <Box display='flex' flexDirection='row' style={rightContentStyle}>
          <QuickBookingServiceContent
            staffs={staffs} getListStaff={getListStaff}
            onChooseNumCustomer={onChooseNumCustomer}
            isDetail
          />
        </Box>
      </Box>
      <QuickBookingTimeContent isDetail forceCalculateTime timeRef={timeRef} onPickDate={onPickDate} />
    </FormContainer>
  );
};

export default AppointmentDetailV3UI;

const DurationBox = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  span {
    color: #6FABB6;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 30px;
    text-transform: capitalize;
  }
`;

const rightContainerStyle: React.CSSProperties = {
  height: '100%',
};
const rightContentStyle: React.CSSProperties = {
  flexGrow: 1,
  background: '#F6F7FC',
};

const FormContainer = styled.div`
  display: flex;
  flex: 1;
  height: calc(100vh - 76px - 90px);
  .error-text-validate {
    color: #d2464f;
    text-align: center;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;


const ApppointmentTime = styled.div`
display: flex;
align-items: center;
gap: 8px;
transform: translateY(-3px);
&:active, &:hover {
  opacity: 0.7;
}
span.label {
  color: #505050;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
span.value {
  color: #1D2129;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px; /* 166.667% */
  text-transform: capitalize;
}
`;
